import type { FormEvent, ChangeEvent } from 'react';
import { SectionRow } from '~/components/dialogs/settings/SectionContainer';
import { Button } from '~/components/ui/Button';
import { Input } from '~/components/ui/Input';

interface RenameFormProps {
  title: string;
  value: string;
  placeholder: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: FormEvent) => Promise<void>;
  isLoading?: boolean;
  isDisabled?: boolean;
  validateErrorMessage?: string;
}

export const RenameForm = (props: RenameFormProps) => {
  const { title, value, placeholder, handleChange, handleSubmit, isLoading, isDisabled, validateErrorMessage } = props;

  return (
    <SectionRow
      title={title}
      layout="vertical"
      innerClassName="flex flex-col gap-1.5"
      titleClassName="font-semibold text-sm mb-0"
      action={
        <form onSubmit={handleSubmit} className="flex items-center gap-2 lg:min-w-[55%] lg:flex-none flex-1 relative">
          <Input
            className="flex-1"
            value={value}
            size="sm"
            onChange={handleChange}
            disabled={isLoading}
            placeholder={placeholder}
          />
          <Button variant="secondary" type="submit" loading={isLoading} disabled={isDisabled || !!validateErrorMessage}>
            Save
          </Button>
          {validateErrorMessage && (
            <p className="text-xs text-bolt-elements-item-contentDanger absolute -bottom-5 left-0">
              {validateErrorMessage}
            </p>
          )}
        </form>
      }
    />
  );
};
